import { DefaultProductOptions } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

export const getClickLeaveRemainingBlankTag = (options: DefaultProductOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );
  const clickLeaveRemainingBlankEvent = [
    {
      eventInfo: {
        eventName: 'recipient address',
        eventAction: 'skip remaining',
      },
    },
  ];

  const { modal, user } = getPODModalTag(
    'Address the Envelope - Recipient',
    clickLeaveRemainingBlankEvent,
    options.projectID,
  );

  return {
    modal,
    product,
    user,
  };
};
